export default "__VITE_ASSET__BavHzLCM__"